/** Meta (Facebook) Pixel helpers — base script lives in index.html. */

export const META_PIXEL_ID = "1397037811741411";

/** Custom Pixel events must use fbq('trackCustom', …). */
const META_CUSTOM_EVENTS = new Set(["SignUpStart"]);

const GOOGLE_SIGNUP_PENDING_KEY = "meta_google_signup_pending";

/**
 * Fire a Meta Pixel event. Safe if the pixel script is missing.
 * Standard events use `track`; custom events use `trackCustom`.
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackMetaEvent(eventName, params) {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;

  const command = META_CUSTOM_EVENTS.has(eventName) ? "trackCustom" : "track";

  if (params && Object.keys(params).length > 0) {
    window.fbq(command, eventName, params);
    return;
  }
  window.fbq(command, eventName);
}

/** Mark that Google auth was started from the signup form. */
export function markGoogleSignupPending() {
  try {
    sessionStorage.setItem(GOOGLE_SIGNUP_PENDING_KEY, "1");
  } catch {
    // Private mode / blocked storage — skip quietly.
  }
}

/**
 * Consume the Google-signup pending flag (one-shot).
 * @returns {boolean}
 */
export function consumeGoogleSignupPending() {
  try {
    const pending = sessionStorage.getItem(GOOGLE_SIGNUP_PENDING_KEY) === "1";
    sessionStorage.removeItem(GOOGLE_SIGNUP_PENDING_KEY);
    return pending;
  } catch {
    return false;
  }
}
